import React from 'react';
import { TableCell } from '@mui/material';

export default class GridEntityCell extends React.Component {
    render() {
        const { items, id } = this.props.field;
        const value = items.find((item) => item.id === this.props.value);
        const baseStyle = this.props.styles || {};
        return (
            <TableCell key={id} align="left" sx={{ ...baseStyle }}>
                {value ? value.name : ''}
            </TableCell>
        );
    }
}
